import { render } from "./orgCourseAnalyseCreate.vue?vue&type=template&id=d8013c7e&scoped=true"
import script from "./orgCourseAnalyseCreate.vue?vue&type=script&lang=js"
export * from "./orgCourseAnalyseCreate.vue?vue&type=script&lang=js"

import "./orgCourseAnalyseCreate.vue?vue&type=style&index=0&id=d8013c7e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8013c7e"]])

export default __exports__